// extracted by mini-css-extract-plugin
export var attachmentContainer = "_h7-0";
export var fileList = "_h7-2";
export var removeFileButton = "_h7-1";